import { token } from '@atlaskit/tokens';

import { type GroupBase, type StylesConfig } from './Select.tsx';

export const getBaseSelectMenuStyles = <
  Option extends object,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(): StylesConfig<Option, IsMulti, Group> => ({
  menu: (base) => ({
    ...base,
    width: 'max-content',
    minWidth: '100%'
  })
});

export const getCompactSelectStyles = <
  Option extends object,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>
>(): StylesConfig<Option, IsMulti, Group> => ({
  menu: (base) => ({
    ...base,
    width: '100%',
    minWidth: '100%'
  }),
  control: (base, state) => ({
    ...base,
    backgroundColor: token('color.background.input'),
    borderColor: state.isFocused ? token('color.border.focused') : token('color.border'),
    borderRadius: token('radius.medium'),
    borderStyle: 'solid',
    borderWidth: token('border.width'),
    boxShadow: 'none',
    '&:hover': {
      borderColor: state.isFocused ? token('color.border.focused') : token('color.border')
    }
  }),
  valueContainer: (base) => ({
    ...base,
    paddingBlock: '0'
  })
});
